import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  variant?: "default" | "unstyled" | "search";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, variant = "default", onKeyDown, ...props }, ref) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      // Handle Cmd+A / Ctrl+A to select all text in the input
      // This prevents global keyboard shortcuts from intercepting the event
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "a") {
        e.stopPropagation();
        e.currentTarget.select();
      }
      onKeyDown?.(e);
    };

    return (
      <input
        type={type}
        className={cn(
          variant === "default" &&
            "flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          variant === "unstyled" &&
            "flex  h-9 w-full py-1 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:cursor-not-allowed disabled:opacity-50",
          variant === "search" &&
            "w-full pl-9 h-7 bg-secondary-200 text-xs text-secondary-n-50 placeholder:text-text-muted border-0 focus-within:border-primary-0 focus-within:border transition",
          className,
        )}
        ref={ref}
        onKeyDown={handleKeyDown}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";

export { Input };
